import type {AddressValue} from 'shells/row/address-row/types';

import {Body} from '../../../typography/body';

import {AddressRowEditState} from '../../address-row/address-row-edit-state';

import type {CustomFieldAddressValue} from '../helpers';

type Props = {
    name: string;
    addressValue: CustomFieldAddressValue | null | undefined;
    updateAddress: (
        address1: string,
        address2: string,
        address3: string,
        city: string,
        state: string,
        postalCode: string,
        country: string
    ) => Promise<any>;
    isEditing: boolean;
    setIsEditing: (isEditing: boolean) => void;
};

export function AddressCustomField(props: Props) {
    const handleUpdateAddress = (value: AddressValue) => {
        return props.updateAddress(
            value.address1,
            value.address2,
            value.address3,
            value.city,
            value.state,
            value.postalCode,
            value.country
        );
    };
    const hasAddressValue =
        props.addressValue && props.addressValue.value && props.addressValue.value.fullAddress;

    if (props.isEditing) {
        return (
            <AddressRowEditState
                addressValue={props.addressValue?.value ?? null}
                isEditing={props.isEditing}
                setIsEditing={props.setIsEditing}
                updateAddress={handleUpdateAddress}
            />
        );
    }

    return (
        <Body
            size='small'
            color={hasAddressValue ? 'medium' : 'light'}
            maintainLineBreaks={true}
            wrapAnywhere={true}
        >
            {/* @ts-expect-error */}
            {hasAddressValue ? props.addressValue.value.fullAddress : `Add ${props.name}…`}
        </Body>
    );
}
